import { render, staticRenderFns } from "./BullkAssignOperatorSidebar.vue?vue&type=template&id=b80274ca&scoped=true"
import script from "./BullkAssignOperatorSidebar.vue?vue&type=script&lang=js"
export * from "./BullkAssignOperatorSidebar.vue?vue&type=script&lang=js"
import style0 from "./BullkAssignOperatorSidebar.vue?vue&type=style&index=0&id=b80274ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80274ca",
  null
  
)

export default component.exports